import { render, staticRenderFns } from "./index.vue?vue&type=template&id=04c71c8b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c71c8b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04c71c8b')) {
      api.createRecord('04c71c8b', component.options)
    } else {
      api.reload('04c71c8b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=04c71c8b&scoped=true&", function () {
      api.rerender('04c71c8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics/supply-print-log/modules/table-list/index.vue"
export default component.exports